/* eslint css-modules/no-unused-class: [2, { markAsUsed: ['wrapper', 'headingWrapper', 'heading', 'clear', 'list', 'advancedFiltersHeader', 'advancedFilters', 'productTypes', 'restProductTypes', 'active', 'submit'] }] */
import dynamic from 'next/dynamic';

import GlassLayer from '@templates/GlassLayer';

import classes from './FilterPanel.module.scss';

const FilterPanel = dynamic(() => import('./FilterPanel'), {
  ssr: false,
  loading: () => <GlassLayer position="sticky" className={classes.loader} />,
});

export default FilterPanel;
